import { Icon, MenuItem } from '@chakra-ui/react';
import { FiEdit } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export const MenuItemEditPage = (props: {
  pageId: string
}) => {

  const navigate = useNavigate();

  return (
    <MenuItem onClick={() => navigate(`/admin/page/${props.pageId}`)} icon={<Icon as={FiEdit} />} >Edit this page</MenuItem>
  )
}
